import { createContext } from 'react';

import type { Services } from '../../types';

// Todo - convert this to a named export
// eslint-disable-next-line import/no-default-export
export default createContext<Services.DataServiceContext>(
  {} as Services.DataServiceContext,
);
